import { render, staticRenderFns } from "./search_infoTags.vue?vue&type=template&id=d3cd0ce4&"
import script from "./search_infoTags.vue?vue&type=script&lang=js&"
export * from "./search_infoTags.vue?vue&type=script&lang=js&"
import style0 from "./search_infoTags.vue?vue&type=style&index=0&id=d3cd0ce4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports